import { useState } from "react";

// debugging HOC that prints the data used by the component
export const withDebug = (Component) =>
  function WithDebugHOC(props) {
    const [showData, setShowData] = useState(false);
    console.log(Component.name, props);
    return (
      <div css={{ border: "2px dotted black", fontSize: "1.5em" }}>
        <Component {...props} />
        <button type="button" onClick={() => setShowData(!showData)}>
          Show Data
        </button>
        {showData && (
          <pre>
            &lt;{Component.name}&gt;
            <br />
            {JSON.stringify(props, false, "\t")}
            <br />
            &lt;/{Component.name}&gt;
          </pre>
        )}
      </div>
    );
  };
